export const ONGLET_EMPLOYEUR = 'Employeur' as const
export const ONGLET_FORMATION = 'Formation' as const
export const ONGLET_PRESTATION = 'Prestation' as const
export const ONGLET_CONTRAT = 'Contrat' as const
